import { useEffect, useState } from "react";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _ActaComiteItem, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import { Modal } from "../../../../../theme/Component/Modal";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import AutoChart from "../../../../../../core/graph/AutoChart";
import useModal, { MODAL_LG, MODAL_md } from "../../../../../theme/Component/hooks/useModal";
import { DropDown } from "../../../../../theme/Component/DropDown";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { LoanLineEditor } from "../../../../../admin/CreditPotfolio/LoanLine/LoanLineEditor";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { InputDate } from "../../../../../theme/Input/InputDate";

interface Props {
    idActaComite: number;
    acta?: any;
}

interface formData {
    IDPayrollEntity: number;
    IDAccount: number;
    IDLoanLine: number;
}


export const ActaComiteItem = ({ idActaComite, acta = {} }: Props) => {

    const _item = useDataBean(_ActaComiteItem);
    const { instance, setBean, bean, lista, setLista } = _item;
    const paginador = usePaginator();

    const modalGraph = useModal("Grafica", MODAL_LG);

    const [modal, setModal] = useState<any>({ view: false, btnClose: true, btnSubmit: true, format: 'modal-md', });
    const [filter, setFilter] = useState<Partial<formData>>({});
    const modalRegistrarCreditos = useModal("Registrar Creditos", MODAL_md);
    const [fechaDesembolso, setFechaDesembolso] = useState<any>(_single.getCurrenDate());

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        const props: any = {
            IDActaComite: idActaComite
        }

        if (filter.IDAccount) props.IDAccount = filter.IDAccount;
        if (filter.IDLoanLine) props.IDLineLoan = filter.IDLoanLine;

        instance.getActaComiteItems(paginador.page, 15, props).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List);
            }
        ).catch(
            errr => { toast.error(errr) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDActaComiteItem', visible: false, mask: MASK_NUMBER },
        { title: 'IDAccount', property: 'IDAccount', visible: false, mask: MASK_NUMBER },
        { title: 'IDAfiliado', property: 'IDCreditAffiliate', visible: false, mask: MASK_NUMBER },
        { title: 'Identificacion', property: 'nit', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'EntityName', visible: true },
        { title: 'Monto Aprovado', property: 'AmountApproved', visible: true, mask: MASK_MONEY },
        { title: 'Capital', property: 'DeductionCapital', visible: true, mask: MASK_MONEY },
        { title: 'Intereses', property: 'DeductionInterest', visible: true, mask: MASK_MONEY },
        { title: 'Cuotas', property: 'Cuotes', visible: true, mask: MASK_NUMBER },
        { title: 'Novacion', property: 'NovacionList', visible: true },
        { title: 'Desembolso', property: 'Amount', visible: true, mask: MASK_MONEY },
        { title: 'No. Crédito', property: 'CreditNumberStr', visible: true },
        { title: 'Caja Nominadora', property: 'CajaNominadora', visible: true },
        { title: 'Linea Crédito', property: 'NameLoanLine', visible: true },
        { title: 'Cuidad', property: 'CiudadName', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        // { title: 'Fecha de Corte', property: 'CutDate', visible: true, mask: MASK_DATE },
    ]


    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-line', visible: true, evento: () => { setModal({ ...modal, view: true, name: "Editar Item del comite" }) } },
            { titulo: 'Registrar Crédito', icono: 'ri-edit-line', visible: true, evento: () => { modalRegistrarCreditos.open() } },
            // { titulo: 'Eliminar Solicitud', icono: 'ri-delete-bin-line', visible: _single.canDelete() && (acta.StateProcess == 3 || acta.StateProcess == null), evento: () => { modalRegistrarCreditos.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const updateItem = () => {
        instance.updateActaComiteItem(bean).then(
            (resp) => {
                setBean({});
                getLista();
                setModal({ ...modal, view: false });
            }
        )
    }
    const registrarCreditos = () => {
        console.log(fechaDesembolso);
        instance.registerCreditActaItem(bean.IDActaComiteItem, fechaDesembolso, _single.getAccountID()).then(
            (resp: any) => {
                toast.success("Credito resitrado");
                modalRegistrarCreditos.close();
                getLista();
            }
        )
    }
    const deleteItem = () => {
        _item.deleteItem(bean.IDActaComiteItem).then(
            (resp: any) => {
                toast.success("Item eliminado");
                getLista();
            }
        )
    }
    const actionsDropDown = [
        { id: 1, name: 'Reporte Gráfico', permiso: null, activo: true },
    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id == 1) {
                            modalGraph.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }

    return (
        <div className="row">
            <div className="col-md-4">
                <AccountEditor idAccount={filter.IDAccount} onChange={(e) => { setFilter({ ...filter, "IDAccount": e.IDAccount }) }} label="Tercero" />
            </div>
            {/* <div className="col-md-4">
                <LoanLineEditor multiSelect label="Linea" onChange={(e) => { setFilter({ ...filter, "IDLoanLines": e.IDList }) }} />
            </div> */}
            {/* <div className="col-md-4">
                <PayrollEntitySelect label="Caja Nominadora" idSelector={filter.IDPayrollEntity} onChange={(e) => { setFilter({ ...filter, "IDPayrollEntity": e }) }} returnType="ID" />
            </div> */}
            <div className="col-md-4">
                <LoanLineEditor onChange={(e) => { setFilter({ ...filter, IDLoanLine: e?.IDLoanLine }) }} label="Linea de Credito" />
            </div>
            <div className="col-md-3">
                <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} useMargin />
            </div>
            <div className="col-md-12">
                <BasicTable
                    headButtons={buttons()}
                    head={head} body={lista}
                    rowSet={setBean}
                    listButtons={listaBotones()}
                    records={paginador}
                />

                <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <InputMoney _value={bean.AmountApproved} onChange={(e) => { setBean({ ...bean, AmountApproved: e }) }} _label="Monto Aprovado" />
                        </div>
                        <div className="col-md-12">
                            <InputMoney _value={bean.DeductionCapital} onChange={(e) => { setBean({ ...bean, DeductionCapital: e }) }} _label="Capital" />
                        </div>
                        <div className="col-md-12">
                            <InputMoney _value={bean.DeductionInterest} onChange={(e) => { setBean({ ...bean, DeductionInterest: e }) }} _label="Intereses" />
                        </div>
                        <div className="col-md-12">
                            <label >No. Crédito</label>
                            <input type="text" className="form-control" value={bean.CreditNumberStr} onChange={(e) => { setBean({ ...bean, CreditNumberStr: e.target.value }) }} />
                        </div>
                        <div className="col-md-12">
                            <AccountEditor idAccount={bean.IDAccount} label="Tercero" onChange={(e) => { setBean({ ...bean, IDAccount: e.IDAccount }) }} />
                        </div>
                    </div>
                </Modal>
                <Modal modal={modalGraph.modal} updateModal={modalGraph.setModal}>
                    <AutoChart data={lista} head={head} useIndexAsXLabel={true}
                        xOptions={['CajaNominadora', 'NameLoanLine', 'CiudadName']}
                        yOptions={['AmountApproved', 'DeductionCapital', 'DeductionInterest', 'Amount']} />

                </Modal>
                <Modal modal={modalRegistrarCreditos.modal} updateModal={modalRegistrarCreditos.setModal} eventModal={registrarCreditos} onSubmitLabel="Registrar">
                    <div className="row">
                        <div className="col-md-6">
                            <InputDate name="aprobacion" value={bean.FechaComite} label="Fecha Comite" _disable={true} setDate={(e) => { setFechaDesembolso(e) }} />
                        </div>
                        <div className="col-md-6">
                            <InputDate name="Desembolso" value={fechaDesembolso} label="Fecha Desembolso" setDate={(e) => { setFechaDesembolso(e) }} />
                        </div>
                        <div className="col-md-12 p-2">
                            <strong>Nota:</strong> Para creditos con primera cuota en el siguiente mes usar fecha desembolso ultimo dia del mes de aprobación
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    )
}